import React from 'react';

import { Wrapper, Heading, List, ListItem, Label, StyledIcon } from './Icon.styled';

export interface Props {
    heading: string;
    items: {
        label: string;
        icon: React.ElementType;
        colour?: string;
    }[];
}

const Icon: React.FC<Props> = props => {
    const { heading, items } = props;

    return (
        <Wrapper>
            <Heading>{heading}</Heading>
            <List>
                {items.map(item => (
                    <ListItem key={item.label}>
                        <StyledIcon as={item.icon} $colour={item.colour} />
                        <Label>{item.label}</Label>
                    </ListItem>
                ))}
            </List>
        </Wrapper>
    );
};

export default Icon;
